export const QUERY_KEYS = {
  OIDC_USER_INFO: 'oidc-user-info',
  USER: 'user-v2',
  ORGANIZATION: 'organization',
  INDEXING_STATISTICS: 'indexing-statistics',
  INDEXING_CONFIGURATION: 'indexing-configuration',
  TASK_TRACKER_SUMMARY: 'task-tracker-summary',
  INSIGHTS: 'insights',
  QODO_GEN_INSIGHTS: 'qodo-gen-insights',
  QODO_MERGE_INSIGHTS: 'qodo-merge-insights',
  ORGANIZATION_ACCESS_REQUESTS: 'organization-access-requests',
  ORGANIZATION_MEMBERS: 'organization-members',
  ORGANIZATION_ENV_MEMBERS: 'organization-env-members',
  WORKSPACE_MEMBERS: 'workspace-members',
  RULES: 'rules',
  RULES_METADATA: 'rules-metadata',
  ORGANIZATION_MEMBERS_EXPORT: 'organization-members-export',
  TEAM: 'team',
  TEAM_USERS: 'team-users',
  ORGANIZATION_TEAMS: 'organization-teams',
  USER_TEAMS: 'user-teams',
  TEAMS_PLANS: 'plans',
  RULES_INSIGHTS: 'rules-insights',
  RULE_INSIGHTS: 'rule-insights',
  RULES_ANALYTICS_EXPORT: 'rules-analytics-export',
  BILLING_QUOTA_BALANCE: 'billing-quota-balance',
  BILLING_INFO: 'billing-info',
  BILLING_ACCOUNT_INFO: 'billing-account-info',
  BILLING_RECOMMENDATION: 'billing-recommendation',
  BILLING_PACKAGES: 'billing-packages',
  GIT_INSTALLATIONS: 'git-installations',
  GIT_REPOSITORIES: 'git-repositories',
  GIT_INSTALLATION_TEST_CONNECTION: 'git-installation-test-connection',
  GIT_INTEGRATION_WEBHOOK_URL: 'git-integration-webhook-url',
  BILLING_ANALYTICS: 'billing-analytics',
  BILLING_REVIEWS: 'billing-reviews',
  RELATED_RULES: 'related-rules',
  FEATURE_ENABLED: 'feature-enabled',
  INVITES: 'invites',
  FINDINGS: 'findings',
  FINDINGS_INSIGHTS: 'findings-insights',
  FINDINGS_FILTERS: 'findings-filters',
  FINDINGS_EXPORT: 'findings-export',
  FINDINGS_IMPACT_REPORT: 'findings-impact-report',
  PERSONA_FINDINGS_STATS: 'persona-findings-stats',
  PERSONAS: 'personas',
  PERSONA: 'persona',
  PERSONA_PROMPTS: 'persona-prompts',
  PERSONA_AGENT_RUN: 'persona-agent-run',
  PERSONA_VERSIONS: 'persona-versions',
  PERSONA_VERSION: 'persona-version',
  PERSONAS_CONFIG: 'personas-config',
  API_KEYS: 'api-keys',
  CONFIG: 'config',
  SKILLS: 'skills',
  SKILLS_INSIGHTS: 'skills-insights',
  AZURE_AVAILABLE_REPOSITORIES: 'azure-available-repositories',
  AZURE_SERVICE_PRINCIPAL_STATUS: 'azure-service-principal-status',
  BITBUCKET_CONFIG: 'bitbucket-config',
  BITBUCKET_OAUTH_SESSION: 'bitbucket-oauth-session',
  BITBUCKET_WIZARD_SELECTION_OPTIONS: 'bitbucket-wizard-selection-options',
  GERRIT_IMPORT_STATUS: 'gerrit-import-status',
  AZURE_INSTALLATIONS_STATUS: 'azure-service-principal-status',
  GITLAB_GROUPS: 'gitlab-groups',
  GITLAB_REPOSITORIES: 'gitlab-repositories',
  GITLAB_PROVISION_STATUS: 'gitlab-provision-status',
  GITLAB_PROVISION_GROUPS_AND_PROJECTS: 'gitlab-provision-groups-and-projects',
  GITLAB_INSTALLATION_GROUPS_AND_PROJECTS:
    'gitlab-installation-groups-and-projects',
  GITLAB_UNINSTALL_STATUS: 'gitlab-uninstall-status',
  GITLAB_MANAGE_STATUS: 'gitlab-manage-status',
  INTEGRATIONS_CONNECTION_STATUS: 'integrations-connection-status',
  CROSS_REPO_EDGES: 'cross-repo-edges',
  CROSS_REPO_EDGE_PAIR: 'cross-repo-edge-pair',
  CROSS_REPO_OVERVIEW: 'cross-repo-overview',
  CROSS_REPO_DISCOVERY_RUN: 'cross-repo-discovery-run',
  INSTALLATIONS_COUNTS: 'installations-counts',
  WIKI: 'wiki',
  GIT_REPOSITORY: 'git-repository',
  AUTH_CONFIG: 'auth-config',
  SANDBOX_CONFIGS: 'sandbox-configs',
  SANDBOX_CONFIG: 'sandbox-config',
};

export const INVALIDATE_INVITE_QUERIES = [
  QUERY_KEYS.ORGANIZATION,
  QUERY_KEYS.ORGANIZATION_TEAMS,
  QUERY_KEYS.ORGANIZATION_MEMBERS,
  QUERY_KEYS.TEAM_USERS,
  QUERY_KEYS.TEAM,
  QUERY_KEYS.USER,
  QUERY_KEYS.INVITES,
];
